import { ErrorResponse } from "@apollo/client/link/error";
import React, {
    FormEvent, ReactElement,
    useState,
} from "react";
import useRouting, { Paths, useParams } from "../../../contexts/Routing";

import {
    MicrosoftTeamsAssociationType, useFinishIntegrationMicrosoftTeamMutation,
} from "../../../__generated__/api";
import Alert from "../../../components/theme/alert/Alert";
import Button from "../../../components/theme/button/Button";
import { LoggingHandler } from "../../../contexts/logging/LoggingContext";

enum Step {
    SELECT_PURPOSE = "SELECT_PURPOSE",
    FINISHED = "FINISHED"
}
export default function TeamsInstallChannelCompleted() : ReactElement | null {
    const { getSearchParams } = useRouting();
    const { token } = useParams(Paths.ONBOARDING_TEAMS_INSTALLED);
    const { isAssociated, organization } = getSearchParams(Paths.ONBOARDING_TEAMS_INSTALLED);

    const [nextStep, setNextStep] = useState<Step>();
    const [step, setStep] = useState<Step>(Step.SELECT_PURPOSE);

    const [isValidating, setIsValidating] = useState(false);
    const [error, setError] = useState("");

    const [finishIntegration] = useFinishIntegrationMicrosoftTeamMutation();

    const confirmAssociation = (evt: FormEvent | undefined, type: MicrosoftTeamsAssociationType) => {
        evt?.preventDefault();
        setIsValidating(true);
        LoggingHandler.instance.nextTick(async () => {
            try {
                await finishIntegration({
                    variables: {
                        settings: {
                            token,
                            type,
                        },
                    },
                });
            } catch (err) {
                const { networkError } = err as ErrorResponse;
                if (networkError) {
                    setIsValidating(false);
                    setError("There was an issue validating this domain. Please make sure you enter it correctly.");
                    return;
                }
                throw err;
            }
            setStep(Step.FINISHED);
        });
    };

    return (

        <div className="full-page">
            <div className="centered-container centered-container-lg">
                {error && (
                    <Alert variant="danger" className="mt-2">
                        {error}
                    </Alert>
                )}
                {step === Step.SELECT_PURPOSE && (
                    <div>
                        <div className="d-flex flex-row justify-items-between align-items-center w-100 mt-3">
                            <div>
                                <h4>Setup the channel</h4>
                                <p>
                                    Thank you for installing Foqal&apos;s Microsoft Teams integration. Please enter the vendor
                                    token provided to you to continue pairing this channel with your vendor channel.
                                </p>
                            </div>

                        </div>

                    </div>
                )}

                {step === Step.FINISHED && (
                    <div>
                        <h5>🎉 Done</h5>
                        <p>
                            Finished associating Microsoft Teams with the channel account.
                        </p>
                    </div>
                )}

                {nextStep && (
                    <div className="mt-2 justify-content-end d-flex w-100">
                        <Button
                            onClick={() => {
                                setStep(nextStep);
                                setNextStep(undefined);
                            }}
                            variant="primary"
                            size="large"
                        >
                            Next
                        </Button>
                    </div>
                )}

            </div>
        </div>

    );
}
